import { Dao } from '../../dao';
import {
  IGizmoEvent,
  IPlatformCallbacks,
  IRootGizmoData,
  TOnSubmit,
} from '../../types';
import FlowyGlobal from '../flowy-global';

interface IParams {
  rootGizmoData: IRootGizmoData;
  onSubmitFinish: () => void;
  context: {
    dao?: Dao;
    flowyGlobal?: FlowyGlobal;
    onSubmit?: TOnSubmit;
    params: any;
    parentRootGizmoFid?: string;
    platformCallbacks?: IPlatformCallbacks;
  };
}

function submitRootGizmoDataCB({
  rootGizmoData,
  onSubmitFinish,
  context,
}: IParams): Promise<void> {
  return new Promise<void>(async resolve => {
    const {
      dao,
      flowyGlobal,
      onSubmit,
      params,
      parentRootGizmoFid,
      platformCallbacks,
    } = context;

    if (onSubmit) {
      onSubmit({ rootGizmoData, onSubmitFinish });
    } else {
      await dao?.saveRootGizmoData({
        rootGizmoData: [rootGizmoData],
        publicRG: params['public'],
      });

      if (!parentRootGizmoFid) {
        // If it doesn't have a parent, it means it's a root gizmo. So we sync in order to send
        // filled forms to the server. Then we notify the UI layer that the root gizmo has been
        // saved. And we go back to the previous screen.
        await dao?.sync();
        // await flowyGlobal?.sendNotification({
        //   notification: {
        //     fid: 'n0',
        //     type: 'success',
        //     label: 'Formato almacenado',
        //   },
        // });
        // await platformCallbacks?.platformOperationCB({
        //   operation: 'navigation.back',
        //   params: {},
        // });
      } else {
        // If it has a parentRootGizmoFid it means it's a child gizmo (annex_form), so we're going
        // to send and event through the FlowyGlobal events stream in order to notify the
        // parent gizmo that the child gizmo has been saved.
        const event: IGizmoEvent = {
          type: 'root-gizmo.operation',
          src: {
            type: 'root-gizmo',
            rootGizmoFid: rootGizmoData.formId,
          },
          dest: {
            type: 'gizmo',
            rootGizmoFid: parentRootGizmoFid,
            gizmoFid: params['parent-gizmo-fid'],
          },
          data: {
            rootGizmoOperation: {
              type: 'child.form.lyfecycle.after-submit',
              dataFid: rootGizmoData.fid,
              dataId: rootGizmoData.id,
            },
          },
        };

        if (
          rootGizmoData.belongsTo &&
          typeof rootGizmoData.belongsTo !== 'boolean' &&
          flowyGlobal &&
          event.data?.rootGizmoOperation?.type
        ) {
          event.data.rootGizmoOperation.rootGizmoData = rootGizmoData;
        }
        await flowyGlobal?.sendEvent({ event });
      }
    }
    resolve();
  });
}

export default submitRootGizmoDataCB;
